'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosTimeOutline = function IoIosTimeOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.5c9.7 0 17.5 7.8 17.5 17.5s-7.8 17.5-17.5 17.5-17.5-7.8-17.5-17.5 7.8-17.5 17.5-17.5z m11.5 29c1.5-1.5 2.7-3.2 3.5-5.2 0.9-2 1.3-4.1 1.3-6.3s-0.4-4.3-1.3-6.3c-0.8-2-2-3.7-3.5-5.2s-3.2-2.7-5.2-3.5c-2-0.9-4.1-1.2-6.3-1.2s-4.3 0.3-6.3 1.2c-2 0.8-3.7 2-5.2 3.5s-2.7 3.2-3.5 5.2c-0.9 2-1.2 4.1-1.2 6.3s0.3 4.3 1.2 6.3c0.8 2 2 3.7 3.5 5.2s3.2 2.7 5.2 3.5c2 0.9 4.1 1.3 6.3 1.3s4.3-0.4 6.3-1.3c2-0.8 3.7-2 5.2-3.5z m-12.1-25.2c0-0.4 0.2-0.7 0.6-0.7s0.6 0.3 0.6 0.7-0.2 0.6-0.6 0.6-0.6-0.3-0.6-0.6z m0 27.5c0-0.4 0.2-0.7 0.6-0.7s0.6 0.3 0.6 0.7-0.2 0.6-0.6 0.6-0.6-0.3-0.6-0.6z m13.7-13.8c0-0.4 0.3-0.6 0.7-0.6s0.6 0.2 0.6 0.6-0.3 0.6-0.6 0.6-0.7-0.2-0.7-0.6z m-27.5 0c0-0.4 0.3-0.6 0.7-0.6s0.6 0.2 0.6 0.6-0.3 0.6-0.6 0.6-0.7-0.2-0.7-0.6z m6.9-11.9c0-0.4 0.2-0.6 0.6-0.6s0.7 0.2 0.7 0.6-0.3 0.7-0.7 0.7-0.6-0.3-0.6-0.7z m13.8 23.8c0-0.4 0.2-0.6 0.6-0.6s0.6 0.2 0.6 0.6-0.2 0.6-0.6 0.6-0.6-0.2-0.6-0.6z m5-18.8c0-0.4 0.2-0.6 0.6-0.6s0.6 0.2 0.6 0.6-0.2 0.7-0.6 0.7-0.6-0.3-0.6-0.7z m-23.8 13.8c0-0.4 0.2-0.6 0.6-0.6s0.7 0.2 0.7 0.6-0.3 0.6-0.7 0.6-0.6-0.2-0.6-0.6z m0-13.8c0-0.4 0.2-0.6 0.6-0.6s0.7 0.2 0.7 0.6-0.3 0.7-0.7 0.7-0.6-0.3-0.6-0.7z m23.8 13.8c0-0.4 0.2-0.6 0.6-0.6s0.6 0.2 0.6 0.6-0.2 0.6-0.6 0.6-0.6-0.2-0.6-0.6z m-5-18.8c0-0.4 0.2-0.6 0.6-0.6s0.6 0.2 0.6 0.6-0.2 0.7-0.6 0.7-0.6-0.3-0.6-0.7z m-13.8 23.8c0-0.4 0.2-0.6 0.6-0.6s0.7 0.2 0.7 0.6-0.3 0.6-0.7 0.6-0.6-0.2-0.6-0.6z m8.6-12.5c0.3 0.6 0.2 1.4-0.5 1.7v9.5c0 0.3-0.3 0.7-0.6 0.7s-0.6-0.4-0.6-0.7v-9.5c-0.2-0.1-0.3-0.3-0.5-0.5-0.2-0.4-0.2-0.8 0-1.2l-2.9-4.9c-0.1-0.4-0.1-0.7 0.2-0.9s0.7-0.1 0.8 0.2l3 5c0.4 0 0.9 0.2 1.1 0.6z' })
        )
    );
};

exports.default = IoIosTimeOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-time-outline.js
// module id = 2537
// module chunks = 0